// Single source of truth for the profile URLs this product treats as a usable
// LinkedIn channel. It mirrors radar_private.valid_profile_url in the M3
// migration, which the backend's canonical_linkedin_url writes into: a slug
// with non-ASCII characters (Vietnamese names, for one) is stored
// percent-encoded, so a UI that only accepts bare ASCII would silently hide a
// channel the database and the Act API both consider current.
// Percent-escapes are limited to bytes >= 0x80, matching the database rule that
// canonical ASCII must stay literal: an encoded separator or a duplicate
// spelling of a plain letter is never a valid slug. Full UTF-8 and NFC checking
// stays in the database; this is a display gate over what it already accepted.
const PROFILE_URL = /^https:\/\/www\.linkedin\.com\/in\/([A-Za-z0-9_-]|%[89A-F][0-9A-F])+$/;

export function isLinkedinProfileUrl(url?: string | null): url is string {
  return typeof url === 'string' && PROFILE_URL.test(url);
}
